;(function (angular) {
  'use strict'

  angular
    .module('kilo.config')
    .constant('exportCols', [
      { header: 'Numéro', key: 'number' },
      { header: 'Description', key: 'description' },
      { header: 'Titre', key: 'title' },
      { header: 'Référence', key: 'reference' },
      { header: 'Date', key: 'date' },
      { header: 'Date d\'échéance', key: 'dueDate' },
      { header: 'Balance', key: 'balanceDue' },
      { header: 'Total HT', key: 'total' },
      { header: 'TVA', key: 'totalVAT' },
      { header: 'Total TTC', key: 'fullTotal' },
      { header: 'Balance payée', key: 'balancePaid' },
      { header: 'Status', key: 'status' },
      { header: 'Client', key: 'client.label' }
    ])
})(window.angular)
